import React from "react";
import { makeStyles } from "@material-ui/styles";
import Page from "../../components/Page/Page.Component";

const useStyles = makeStyles(() => ({
  root: {},
}));

function HomeScreen() {
  const classes = useStyles();

  return (
    <Page className={classes.root} title="Home">
      HomeScreen
    </Page>
  );
}

export default HomeScreen;
